import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { VertContainer, VertTypography, Col, Row, VertCollapse } from '@vertem-core/vertice-ds';
import { LuChevronDown, LuHeadphones } from 'react-icons/lu';

import 'Assets/styles/default/components/LikePlus/LikePlusGeneric.less';

import Icon from 'components/Atoms/Icons/Icon';

import { cardCustomLabel, faqFile } from 'Constants/LikePlus';

const LikePlusFAQ = () => {
  const isLargeScreen = useMediaQuery({ minWidth: 769 });

  const [faqItems, setFaqItems] = useState([]);

  useEffect(() => {
    const loadFAQItems = async () => {
      try {
        const module = await import(`./data/${faqFile}`);
        const getTermsData = module.default;

        setFaqItems(getTermsData(cardCustomLabel));
      } catch (error) {
        console.error("Erro ao carregar os items do FAQ:", error);
      }
    };

    loadFAQItems();
  }, []);

  return (
    <VertContainer fluid={true} className='like-plus-faq margin-y-big'>
      <VertContainer className={` ${!isLargeScreen ? 'margin-left-small' : ''}`}>
        <Row gutter={0}>
          <Col className='col-12'>
            <VertTypography.Title type='default' level={1} className='font-w-600'>
              Como podemos te ajudar?
            </VertTypography.Title>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
              {`Aqui você encontra as respostas para as principais dúvidas sobre o cartão ${cardCustomLabel}.`}
            </VertTypography.Paragraph>
          </Col>
          <Col className={` col-12 margin-top-small ${!isLargeScreen ? 'resize-collapse' : ''}`} >
            <VertCollapse
              expandIconPosition="right"
              expandIcon={() => <Icon className="lucide color-detached arrow-collpase" size="24px" component={LuChevronDown} />}
              items={faqItems}
            />
          </Col>
        </Row>
      </VertContainer>
      <VertContainer className='like-plus-contact col-12 margin-bottom-regular vert-bg-light-lighter border-radius-large margin-top-regular'>
        <Row gutter={0} align={`middle`} className='padding-x-regular padding-y-regular'>
          <Col className='col-12 margin-top-small'>
            <Row gutter={0} align={`middle`}>
              <Col className='col-auto margin-right-extra-small'>
                <Icon className="where-use-icon lucide color-neutral-dark" size={`24px`} component={LuHeadphones} />
              </Col>
              <Col className='col'>
                <VertTypography.Paragraph type='default' className='txt-medium font-w-600 w-100 text-left'>
                  Central de atendimento
                </VertTypography.Paragraph>
              </Col>
            </Row>

          </Col>
          <Col className='col-12'>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-500 w-100 text-left margin-top-extra-small'>
              Ainda tem dúvidas? Ligue para:
            </VertTypography.Paragraph>
            <VertTypography.Paragraph type='default' className='txt-medium font-w-500 w-100 text-left margin-top-extra-small'>
              (11) 4020-0221
            </VertTypography.Paragraph>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
              Atendimento de segunda à sexta, das 9h às 18h.
            </VertTypography.Paragraph>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left'>
              Exceto em feriados.
            </VertTypography.Paragraph>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-400 w-100 text-left margin-top-small'>
              Também entre em contato pelo e-mail:
            </VertTypography.Paragraph>
            <VertTypography.Paragraph type='default' className='txt-paragraph font-w-500 w-100 text-left'>
              atendimento@acgsa.com.br
            </VertTypography.Paragraph>
          </Col>
        </Row>
      </VertContainer>
    </VertContainer>

  );
};

export default LikePlusFAQ;
